import React from 'react';
import Select from 'react-select';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import { priceLimit } from 'utils/Helpers';

const BusinessProfileForm = ({ value = {}, onChange, industryOptions = [], isFromOptions = false, onSubmit }) => {
  const handleChange = (field, val) => {
    onChange({
      ...value,
      [field]: val
    });
  };

  const handleCostChange = (field, val) => {
    onChange({
      ...value,
      laborRateCostStructure: {
        ...value.laborRateCostStructure,
        [field]: val
      }
    });
  };

  const selectOptions = industryOptions?.map((opt) => ({
    value: opt._id,
    label: opt.text
  }));

  const handleNumericChange = (field, input) => {
    // allow only numbers + decimal
    let value = input.replace(/[^0-9.]/g, '');

    // prevent multiple decimals
    const parts = value.split('.');

    if (parts.length > 2) {
      value = `${parts[0]}.${parts[1]}`;
    }

    // prevent negative
    if (Number(value) < 0) {
      appToast('Negative values are not allowed.', TOAST_TYPE.WARNING);
      return;
    }

    // markup max 100
    if ((field === 'markup' || field === 'overheadProfit') && Number(value) > 100) {
      appToast(`${field === 'markup' ? 'Markup' : 'Overhead / Profit'} cannot exceed 100%.`, TOAST_TYPE.WARNING);
      return;
    }

    handleCostChange(field, value);
  };

  return (
    <div className="setting-sec">
      {!isFromOptions && (
        <div className="setting-head">
          <div className="setting-head-content">
            <h2>Company Bio</h2>
            <p>Your business profile and billing preferences</p>
          </div>
        </div>
      )}

      <div className="setting-card">
        <div className="company-bio">
          {/* Industry */}
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>Business vertical / industry</label>

                <Select
                  className="form-control select2"
                  placeholder="Select Industry"
                  options={selectOptions}
                  value={
                    value?.businessVerticalIndustry
                      ? {
                          value: value.businessVerticalIndustry.optionId,
                          label: value.businessVerticalIndustry.value
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleChange('businessVerticalIndustry', {
                      optionId: selected.value,
                      value: selected.label,
                      userInputText: ''
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>Business description</label>
                <textarea
                  className="form-control"
                  value={value.businessDescription || ''}
                  onChange={(e) => handleChange('businessDescription', e.target.value)}
                  placeholder="Briefly describe what your business does, who you serve, and what makes you different..."
                />
              </div>
            </div>
          </div>

          {/* Cost Structure */}
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>Labor rate / cost structure (Optional)</label>
              </div>
            </div>
          </div>

          <div className="row cost-structure">
            {/* Hourly Rate */}
            <div className="col-lg-4">
              <div className="form-group">
                <label>Hourly labor rate</label>
                <span className="doller">$</span>
                <input
                  maxLength={priceLimit}
                  type="text"
                  className="form-control"
                  placeholder=" 0.00"
                  value={value?.laborRateCostStructure?.hourlyLaborRate || ''}
                  onChange={(e) => handleNumericChange('hourlyLaborRate', e.target.value)}
                />
              </div>
            </div>

            {/* Markup */}
            <div className="col-lg-4">
              <div className="form-group">
                <label>Markup</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="0"
                  value={value?.laborRateCostStructure?.markup || ''}
                  onChange={(e) => handleNumericChange('markup', e.target.value)}
                />
                <span className="percent">%</span>
              </div>
            </div>

            {/* Overhead */}
            <div className="col-lg-4">
              <div className="form-group">
                <label>Overhead / profit</label>
                <input
                  type="text"
                  placeholder="0"
                  className="form-control"
                  value={value?.laborRateCostStructure?.overheadProfit || ''}
                  onChange={(e) => handleNumericChange('overheadProfit', e.target.value)}
                />
                <span className="percent">%</span>
              </div>
            </div>
            {isFromOptions && (
              <button className="btn-black w-100 round-10" type="button" onClick={onSubmit}>
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessProfileForm;
